import script from "./basic-settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./basic-settings.vue?vue&type=script&setup=true&lang=ts"

import "./basic-settings.vue?vue&type=style&index=0&id=ffd73f78&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffd73f78"]])

export default __exports__